module.exports = __webpack_public_path__ + "img/coquillages-en-ligne-boutrais-small.075153a9.png";